import { useState, useEffect } from 'react';

const useItemDataAPI = (pageNo, activeCategories, searchValue, host) => {
  const styleUrl = host.slice(-1) !== '/' ? host : host.slice(0, -1);
  const hostUrl = `${styleUrl}/umbraco/api/items`;
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(null);
  const [isPending, setIsPending] = useState(true);
  const [error, setError] = useState(null);
  const L1S =
    activeCategories.L1[0] === '1108' ? 0 : Number(activeCategories.L1);
  const L1String = `&l1=${L1S}`;
  const L2loop = activeCategories.L2
    ? activeCategories.L2.map((l) => {
        return `&l2=${l}`;
      })
    : '';
  const L2String = L2loop.length === 0 ? '' : L2loop.join('');
  const L3loop = activeCategories.L3
    ? activeCategories.L3.map((l) => {
        return `&l3=${l}`;
      })
    : '';
  const L3String = L3loop.length === 0 ? '' : L3loop.join('');
  const Qterms =
    searchValue.length > 0
      ? `&q=${searchValue.join('').replace(/ /g, '%20')}`
      : `&q=0`;
  const clearPageData = () => {
    if (pageNo === 1) {
      setData([]);
    }
  };
  useEffect(() => {
    clearPageData();
    setIsPending(true);
    const endpoint =
      searchValue.length > 0
        ? `${hostUrl}/search?p=${pageNo}${Qterms}`
        : `${hostUrl}/list?p=${pageNo}${L1String}${L2String}${L3String}`;

    const fetchData = async () => {
      try {
        const response = await fetch(endpoint);
        const jsonResponse = await response.json();

        setData((prev) => {
          return [...new Set([...prev, jsonResponse.items])];
        });
        setTotalPages(jsonResponse.totalPages);
        setIsPending(false);
        setError(null);
      } catch (error) {
        console.log('Error:', error);
        setIsPending(false);
        setError('Could not fetch the data');
      }
    };
    if (totalPages === null || totalPages >= pageNo) {
      fetchData();
    }
  }, [
    pageNo,
    activeCategories.L1,
    activeCategories.L2,
    activeCategories.L3,
    searchValue,
  ]);

  return { data, totalPages, isPending, error };
};
export default useItemDataAPI;
